export default "__VITE_ASSET__BIQUyZRK__"